module.exports = __webpack_public_path__ + "static/1.2_543x800_Mobile_Hero_2X-c633930d6436fe4a07b1f6a3be6e0c81.png";